import { Student } from "../../../../Utilities";
import { ClassYearFormat } from "../../../Format";
import { ClassYearUtilities } from "../../../Utilities";
import * as PersonComponents from "../../Person";
import { IconStudent } from "../Icon";

export type StudentIconNameDescriptionProps = Omit<PersonComponents.PersonIconNameDescriptionProps, "person"> & {
	student: IconStudent & Pick<Student, "graduationYear" | "yearsFromGraduation">;
};

export function StudentIconNameDescription({ student, description, ...props }: StudentIconNameDescriptionProps) {
	const { classYear } = ClassYearUtilities.useClassYear(student.yearsFromGraduation);
	const defaultDescription =
		!classYear || student.graduationYear === null ? "Student" : ClassYearFormat.name(classYear);

	return (
		<PersonComponents.PersonIconNameDescription
			person={student.person}
			description={description ?? defaultDescription}
			linkID={student.id}
			{...props}
		/>
	);
}
